import React, { useRef, useEffect } from 'react';
import { Rect, Text as KonvaText, Line, Group, Transformer } from 'react-konva';

export const NewsletterBlockShape = ({ element, isSelected, onSelect, onChange }) => {
  const groupRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (isSelected && trRef.current && groupRef.current) {
      trRef.current.nodes([groupRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const renderBlockContent = () => {
    switch (element.blockType) {
      case 'header':
        return (
          <>
            <Rect width={element.width} height={element.height} fill={element.backgroundColor || '#064E3B'} cornerRadius={0} />
            <KonvaText y={element.height / 2 - 15} width={element.width} text={element.title || 'Newsletter Header'} fontSize={24} fill={element.textColor || '#FFFFFF'} fontFamily="Arial" fontStyle="bold" align="center" />
          </>
        );
      case 'textBlock':
        return (
          <>
            <Rect width={element.width} height={element.height} fill={element.backgroundColor || '#FFFFFF'} stroke="#E5E5E5" strokeWidth={1} />
            <KonvaText x={10} y={10} width={element.width - 20} text={element.content || 'Text content block - users will edit this'} fontSize={14} fill={element.textColor || '#333333'} fontFamily="Arial" />
          </>
        );
      case 'imageBlock':
        return (
          <>
            <Rect width={element.width} height={element.height} fill="#F0F0F0" stroke="#CCCCCC" strokeWidth={1} dash={[5, 5]} />
            <KonvaText y={element.height / 2 - 10} width={element.width} text="IMAGE BLOCK" fontSize={16} fill="#888888" fontFamily="Arial" align="center" />
          </>
        );
      case 'buttonBlock':
        return (
          <>
            <Rect width={element.width} height={element.height} fill="#FFFFFF" />
            <Rect x={(element.width - 150) / 2} y={(element.height - 40) / 2} width={150} height={40} fill={element.buttonColor || '#064E3B'} cornerRadius={4} />
            <KonvaText y={element.height / 2 - 8} width={element.width} text={element.buttonText || 'Click Here'} fontSize={14} fill="#FFFFFF" fontFamily="Arial" fontStyle="bold" align="center" />
          </>
        );
      case 'divider':
        return (
          <>
            <Rect width={element.width} height={element.height} fill="transparent" />
            <Line points={[20, element.height / 2, element.width - 20, element.height / 2]} stroke={element.dividerColor || '#E5E5E5'} strokeWidth={2} />
          </>
        );
      case 'spacer':
        return <Rect width={element.width} height={element.height} fill="transparent" stroke="#E5E5E5" strokeWidth={1} dash={[3, 3]} />;
      case 'logoBlock':
        return (
          <>
            <Rect width={element.width} height={element.height} fill={element.backgroundColor || '#FFFFFF'} stroke="#E5E5E5" strokeWidth={1} />
            <Rect x={(element.width - 120) / 2} y={(element.height - 50) / 2} width={120} height={50} fill="#E5E5E5" stroke="#CCCCCC" strokeWidth={1} dash={[5, 5]} />
            <KonvaText y={element.height / 2 - 8} width={element.width} text="LOGO" fontSize={14} fill="#888888" fontFamily="Arial" align="center" />
          </>
        );
      case 'signatureBlock':
        return (
          <>
            <Rect width={element.width} height={element.height} fill={element.backgroundColor || '#F9FAFB'} stroke="#E5E5E5" strokeWidth={1} />
            <KonvaText x={20} y={15} text={element.signatureName || 'Your Name'} fontSize={16} fill="#333333" fontFamily="Arial" fontStyle="bold" />
            <KonvaText x={20} y={38} text={element.signatureTitle || 'Real Estate Agent'} fontSize={12} fill="#666666" fontFamily="Arial" />
            <KonvaText x={20} y={58} text={element.signaturePhone || '(555) 123-4567'} fontSize={12} fill="#666666" fontFamily="Arial" />
            <KonvaText x={20} y={78} text={element.signatureEmail || 'agent@example.com'} fontSize={12} fill="#0ea5e9" fontFamily="Arial" />
          </>
        );
      default:
        return <Rect width={element.width} height={element.height} fill="#F5F5F5" />;
    }
  };

  return (
    <>
      <Group
        ref={groupRef}
        x={element.x}
        y={element.y}
        draggable={!element.locked}
        onClick={onSelect}
        onTap={onSelect}
        onDragEnd={(e) => {
          onChange({ ...element, x: e.target.x(), y: e.target.y() });
        }}
        onTransformEnd={(e) => {
          const node = e.target;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...element,
            x: node.x(),
            y: node.y(),
            width: Math.max(100, element.width * scaleX),
            height: Math.max(30, element.height * scaleY),
          });
        }}
      >
        {renderBlockContent()}
      </Group>
      {isSelected && !element.locked && (
        <Transformer
          ref={trRef}
          flipEnabled={false}
          enabledAnchors={['middle-left', 'middle-right', 'bottom-center', 'top-center']}
          boundBoxFunc={(oldBox, newBox) => {
            if (Math.abs(newBox.width) < 100 || Math.abs(newBox.height) < 30) return oldBox;
            return newBox;
          }}
        />
      )}
    </>
  );
};
